import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=e137314c&scoped=true"
import script from "./Support.vue?vue&type=script&lang=js"
export * from "./Support.vue?vue&type=script&lang=js"
import style0 from "./Support.vue?vue&type=style&index=0&id=e137314c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e137314c",
  null
  
)

export default component.exports